export default {
  RESIZE: 'RESIZE',
};
